import React, { Component, Fragment, useState } from "react";

import Header from "../../components/Header";
import Footer from "../../components/Footer";
import Sidebar from "../../components/Sidebar";

import { Notify } from "notiflix";


import edit from '../../assets/images/edit.png'


import { useNavigate } from "react-router";

import { getUserDetails } from "../../Features/SiteSettings/siteSettingSlice";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import { useTranslation, I18nextProvider } from "react-i18next";


import { useCustomizeContext } from "../../context";

import { updateProfile } from "../../Features/Profile/profileSlice";
import 'react-loading-skeleton/dist/skeleton.css'


const Editprofile = (props) => {
   const { t, i18n } = useTranslation();


   const {
      loader: {
         loading, setLoading,
      },
      apiResponses: {
         updateRes, setUpdateRes,
      },
      sideMenu: {
         classIsActive, setClassIsActive
      },
   } = useCustomizeContext();

   let navigate = useNavigate();
   let dispatch = useDispatch();

   const [userDetails, setUserDetails] = useState("");

   const [userName, setUserName] = useState("");
   const [userProfile, setUserProfile] = useState("");
   const [userProfilePreview, setUserProfilePreview] = useState("");


   useEffect(() => {
      getUserInfo();
   }, [updateRes]);

   const getUserInfo = async () => {
      let res = await dispatch(getUserDetails());
      setLoading(true);
      setTimeout(() => {
         if (res?.status === true) {
            setUserName(res?.data?.details?.username);
            setUserProfile(res?.data?.details?.profile_picture);
            setUserDetails(res?.data);
            setLoading(false);
         }
         else {
            setLoading(false);
         }
      }, 1000);
   }

   useEffect(() => {
      document.body.classList.remove("SideMenuOpen");
      setClassIsActive(false);
   }, []);

   const format = ["image/jpg", "image/png", "image/jpeg"];


   const handleChange = (event) => {
      const file = event.target.files[0];


      if (!format.includes(file.type)) {
         Notify.failure(`${t('JPG,PNG,JPEG format only allowed')}`, {
            showOnlyTheLastOne: true,
            clickToClose: true,
            timeout: 1500,
         });
      }
      else {
         setUserProfile(event.target.files[0]);
         let reader = new FileReader();
         reader.onload = function () {
            setUserProfilePreview(reader.result);
         };
         reader.readAsDataURL(event.target.files[0]);
      }
   };


   const updateUserProfile = async (event) => {
      event.preventDefault();

      let data = new FormData();

      data.append("username", userName);
      data.append("profile_picture", userProfile);
      setLoading(true);

      let res = await dispatch(updateProfile(data, "formData"));
      setTimeout(() => {
         if (res?.status === true) {
            setUpdateRes(res);
            setLoading(false);
            navigate("/myprofile");
         }
         else {
            setLoading(false);
         }
      }, 1000);
   }

   return (
      <Fragment>
         <Header />
         <div class="mainbody-content">
            <Sidebar />
            <div class="center-maincnt">
               <div class="inr-container">
                  <div class="center-inrcnt">
                     <div className="editprofilepage-maincnt">
                        <section class="my_profile-sec">
                           <h2>{t("My Profile")}</h2>
                           <div class="my_pro_cdtl">
                              <div class="row justify-content-center align-items-center">
                                 <div class="col-xl-6 col-lg-8 my-3">
                                    <div class="mar_cd ">
                                       <div class="row ">
                                          <div class="col-lg-auto">
                                             <div class="img_edit">
                                                <img src={userProfilePreview ? userProfilePreview : userProfile} alt="" style={{ height: "100px", width: "100px", borderRadius: "inherit" }} />
                                                <div class="setting-pro-2">
                                                   <div class="variants">
                                                      <div class='file'>
                                                         <label for='input-file'>
                                                            <img src={edit} alt="" />
                                                         </label>
                                                         <input id='input-file' onChange={(e) => handleChange(e)} type='file' />
                                                      </div>
                                                   </div>
                                                </div>

                                             </div>
                                          </div>
                                          <div class="col">
                                             <div class="my_pro_2">
                                                <h2>{t("Username")}</h2>
                                                <div class="form-group mb-2">
                                                   <input type="text" class="form-control" defaultValue={userName} onChange={(e) => setUserName(e.target.value)} />
                                                </div>
                                                <p>{t("profile_cond")}</p>
                                                <button class="btn" disabled={loading} onClick={(e) => updateUserProfile(e)}>{t("Modify")}</button>
                                             </div>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </section>
                     </div>
                  </div>
                  <Footer />
               </div>
            </div>
         </div>
      </Fragment>
   );

}

export default Editprofile;